module.exports = __webpack_public_path__ + "img/icon-psim.9dd135d9.png";